import React from 'react';

import { ProductResponse, PROMOTION_TYPE } from 'types';
import { useVnpayPromotion } from 'hooks';
import { DetailPage } from 'modules/product-detail/desktop';
import { getServerSidePropsDetail } from 'modules/product-detail/shared';
import { useCustomPromotion } from '../_module/hooks/useCustomPromotions';
import { ProductDetailProvider } from 'contexts';
import { formatExtraPromotions } from 'helpers';
import { IBannerInlinePlaceholderProps } from '@tekface/smart-activation';

export interface ProductDetailsProps {
  serverProduct: ProductResponse;
  inlineBanners?: IBannerInlinePlaceholderProps<{}>['banners'];
}
const ProductDetails: React.FC = () => {
  const { vnpayPromotions } = useVnpayPromotion('phongvu_vnpay_promotion');
  const { customPromotions } = useCustomPromotion();
  const extraPromotions = formatExtraPromotions(
    vnpayPromotions,
    PROMOTION_TYPE.magento,
  );
  const extraCustomPromotions = formatExtraPromotions(
    customPromotions,
    PROMOTION_TYPE.customMagento,
  );

  return (
    <DetailPage
      extraPromotions={[...extraPromotions, ...extraCustomPromotions]}
    />
  );
};
const ProductDetailsPage: React.FunctionComponent<ProductDetailsProps> = ({
  serverProduct,
  inlineBanners,
}: ProductDetailsProps) => {
  return (
    <ProductDetailProvider
      serverProduct={serverProduct}
      inlineBanners={inlineBanners}
    >
      <ProductDetails />
    </ProductDetailProvider>
  );
};
export const getServerSideProps = getServerSidePropsDetail;
export default ProductDetailsPage;
